import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBadges from "@/components/TrustBadges";
import Services from "@/components/Services";
import GarageDoorOptions from "@/components/GarageDoorOptions";
import Emergency from "@/components/Emergency";
import RealTestimonial from "@/components/RealTestimonial";
import QuoteForm from "@/components/QuoteForm";
import About from "@/components/About";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import AboutPage from "@/pages/AboutPage";
import ProductsCatalogPage from "@/pages/ProductsCatalogPage";
import ServicesPage from "@/pages/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import EmergencyPage from "@/pages/EmergencyPage";
import QuotePage from "@/pages/QuotePage";
import SpringsPage from "@/pages/SpringsPage";
import OpenersPage from "@/pages/OpenersPage";
import CablesPage from "@/pages/CablesPage";
import PanelsPage from "@/pages/PanelsPage";
import TracksPage from "@/pages/TracksPage";
import RollersPage from "@/pages/RollersPage";
import InstallationPage from "@/pages/InstallationPage";
import RepairPage from "@/pages/RepairPage";
import SpringReplacementPage from "@/pages/SpringReplacementPage";
import OpenerServicePage from "@/pages/OpenerServicePage";
import MaintenancePage from "@/pages/MaintenancePage";
import { Toaster } from "@/components/ui/sonner";

const HomePage = () => {
  return (
    <>
      <Hero />
      <TrustBadges />
      <Services />
      <RealTestimonial />
      <Emergency />
      <About />
      <QuoteForm />
      <FAQ />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductsCatalogPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/emergency" element={<EmergencyPage />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/springs" element={<SpringsPage />} />
          <Route path="/openers" element={<OpenersPage />} />
          <Route path="/cables" element={<CablesPage />} />
          <Route path="/panels" element={<PanelsPage />} />
          <Route path="/tracks" element={<TracksPage />} />
          <Route path="/rollers" element={<RollersPage />} />
          <Route path="/installation" element={<InstallationPage />} />
          <Route path="/repair" element={<RepairPage />} />
          <Route path="/spring-replacement" element={<SpringReplacementPage />} />
          <Route path="/opener-service" element={<OpenerServicePage />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
        </Routes>
        <Footer />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
